import { navigate } from 'gatsby'
import clsx from 'clsx'
import { RateStatus } from 'lib/graphql/storeadmin'
import { ColumnsType, Table, TableProps, Tag } from 'components/common'

export interface Rate extends Record<string, string | number> {
  key: string
  title: string
  numberOfItems: number
  status: RateStatus
  createdAt: string
  updatedAt: string
}

type InternalProps = TableProps<Rate>
type Actions = Pick<InternalProps, 'onChange' | 'onRow'>
// TODO: Phase 1 では未使用
// type RowSelection = InternalProps['rowSelection']
export interface RatesTableProps
  extends Omit<InternalProps, 'onChange' | 'onRow'> {
  dataSource: Array<Rate>
}

const columns: ColumnsType<Rate> = [
  {
    key: 'title',
    title: '区分名',
    dataIndex: 'title',
    ellipsis: true,
  },
  {
    key: 'status',
    title: 'ステータス',
    dataIndex: 'status',
    render: (value) => {
      switch (value) {
        case RateStatus.Active:
          return <Tag color={'success'}>アクティブ</Tag>
        case RateStatus.Inactive:
          return <Tag color={'error'}>非アクティブ</Tag>
        case RateStatus.Archived:
          return <Tag color={'default'}>アーカイブ済み</Tag>
        default:
          return
      }
    },
  },
  {
    key: 'numberOfItems',
    title: '区分詳細数',
    dataIndex: 'numberOfItems',
    render: (value) => `${value}件`,
  },
  {
    key: 'createdAt',
    title: '作成日時',
    dataIndex: 'createdAt',
  },
  {
    key: 'updatedAt',
    title: '更新日時',
    dataIndex: 'updatedAt',
  },
]

export const RatesTable = ({
  dataSource,
  ...rest
}: RatesTableProps): JSX.Element => {
  /* TODO: Phase 1 では未使用
  const [selectedRowKeys, setSelectedRowKeys] = useState<Key[]>()
  const rowSelection: RowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys) => setSelectedRowKeys(selectedKeys),
  }
  */

  const onChange: Actions['onChange'] = (
    pagination,
    filters,
    sorter,
    { currentDataSource, action }
  ) => {
    return
  }

  const onRow: Actions['onRow'] = (record, action) => {
    return {
      onClick: async (event) => {
        await navigate(`./${record.key}`)
      },
      // onDoubleClick: (event) => {},
      // onContextMenu: (event) => {},
      // onMouseEnter: (event) => {},
      // onMouseLeave: (event) => {},
    }
  }

  return (
    <>
      <Table<Rate>
        sticky
        pagination={false}
        rowClassName={clsx('cursor-pointer')}
        // TODO: Phase 1 では非表示
        // rowSelection={rowSelection}
        dataSource={dataSource}
        columns={columns}
        onChange={onChange}
        onRow={onRow}
        {...rest}
      />
    </>
  )
}
